export function turboStreamTodoFormUrl(url) {
  if (!url) return null;

  const parsed = new URL(url, window.location.href);
  if (!parsed.pathname.endsWith(".turbo_stream")) {
    parsed.pathname = `${parsed.pathname.replace(/\/$/, "")}.turbo_stream`;
  }

  return parsed.toString();
}

function todoModalStatus() {
  return document.getElementById("quiz-results-add-manage-todo-modal-status");
}

function todoModalLoadError() {
  return document.getElementById(
    "quiz-results-add-manage-todo-modal-load-error",
  );
}

export function announceTodoModalLoading() {
  const error = todoModalLoadError();
  if (error) error.textContent = "";
  const status = todoModalStatus();
  if (status) status.textContent = "Loading lists";
}

export function announceTodoModalLoaded() {
  const status = todoModalStatus();
  if (status) status.textContent = "";
}

export function announceTodoModalLoadError() {
  announceTodoModalLoaded();
  const error = todoModalLoadError();
  if (error) error.textContent = "Unable to load to-do lists. Try again.";
}

export const QUIZ_TODO_MODAL_ROOT_IDS = [
  "quiz-results-add-manage-todo-modal",
  "create-list-modal",
  "remove-todo-confirmation-modal",
];

export function portalQuizTodoModalsToBody() {
  QUIZ_TODO_MODAL_ROOT_IDS.forEach((id) => {
    const node = document.getElementById(id);
    if (!node || node.parentElement === document.body) return;

    document.body.appendChild(node);
  });
}

export function centerTodoModalOverlayScroll(
  modalId = "quiz-results-add-manage-todo-modal",
) {
  const dialog = document.getElementById(`${modalId}-dialog`);
  if (!dialog) return;

  const overflow = dialog.scrollHeight - dialog.clientHeight;
  if (overflow > 0) dialog.scrollTop = overflow / 2;
}
